import { render, staticRenderFns } from "./CadSala.vue?vue&type=template&id=e52fc024&"
import script from "./CadSala.vue?vue&type=script&lang=js&"
export * from "./CadSala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports